import { apiGet } from "./apiClient";

const baseHeaders = { "Content-Type": "application/json" };

export const getApplicationUsersFromAPI = async (token) => {
    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
    };

    return await apiGet("/users", requestInfo);
};
